import APP_RENDER_MODES from '../constants/app-render-modes';
import { Button } from '@llt-frontend/react-material-button';
import ChromelessLayout from './chromeless';
import LEGACY_VIEWER from '../constants/legacy-viewer';
import LegacyViewerLayout from './legacy-viewer';
import PrimaryLayout from './primary';
import PropTypes from 'prop-types';
import React from 'react';
import getBasePathAttributes from '../utilities/routing/get-base-path-attributes';

//

function LazyLayout({
  children,
  layout: Layout = LEGACY_VIEWER ? LegacyViewerLayout : PrimaryLayout,
  ...layoutProps
}) {
  const { renderMode } = getBasePathAttributes();
  const chromeless = [APP_RENDER_MODES.chromeless, APP_RENDER_MODES.uxp].includes(renderMode);

  if (chromeless) {
    Layout = ChromelessLayout;
  }

  //
  // Render

  return (
    <>
      {!chromeless && (
        <Button
          className="skip-to-content"
          href="#main-content"
          iconName="arrow_downward"
          outlined
          trailingIcon
        >
          Skip to main content
        </Button>
      )}

      <Layout {...layoutProps}>
        <React.Suspense fallback={null}>{children}</React.Suspense>
      </Layout>
    </>
  );
}

LazyLayout.propTypes = {
  children: PropTypes.node.isRequired,
  layout: PropTypes.elementType,
};

// Exports
// -------

export default LazyLayout;
